import React, { useEffect, useState } from 'react'
import FillFind from 'components/FillFind'
import FillCheck from 'components/FillCheck'
import SigleSchool from 'components/SigleSchool'
import { querySchoolList } from 'servers/searchSchool/index'
import { ISchoolList } from 'servers/searchSchool/interface'
import useStore from 'store'
import { useDocumentTitle } from 'utils/util'
import { message } from 'antd'
import PadBanner from 'components/PadBanner'
import s from './index.module.less'

const SearchSchool = () => {
  useDocumentTitle('查学校')
  const { state, dispatch } = useStore()
  const [searchRes, setSearchRes] = useState<ISchoolList>()
  const [loading, setLoading] = useState(true)

  const searchCollegesFun = async (params) => {
    setLoading(true)
    const res = await querySchoolList({ ...params })
    const { code, data, description } = res
    if (code === 0) {
      setSearchRes(data)
      setLoading(false)
    } else {
      setLoading(false)
      message.error(description)
    }
  }
  useEffect(() => {
    searchCollegesFun(state.filterParamsData)
  }, [state.filterParamsData])

  useEffect(() => {
    dispatch({ type: 'changeBanner', payload: 'searchSchool' })
  }, [])

  return (
    <>
      <PadBanner bannerName="查学校" />
      <div className={s.SearchSchool}>
        <FillCheck hasAuth sourceType="search" />
        <FillFind
          resNumber={searchRes?.total || 0}
          hasAuth
          type="查院校搜索"
          keyName="schoolName"
          findType="院校"
          typeValue={searchRes?.total || 0}
        />
        <SigleSchool schoolList={searchRes?.list} loading={loading} total={searchRes?.total || 0} />
      </div>
    </>
  )
}

export default SearchSchool
